import { makeStyles } from '@mui/styles';
import { neptunePrimaryDark } from 'apollo-react/colors';
import ChartBar from 'apollo-react-icons/ChartBar';
import ChartPie from 'apollo-react-icons/ChartPie';
import classNames from 'classnames';
import React from 'react';

const useStyles = makeStyles({
  chartIcon: {
    color: ({ color }) => color,
    height: ({ size }) => size,
    width: ({ size }) => size,
  },
  rotate: {
    transform: 'rotate(-270deg)',
  },
});

const ChartIcon = ({ chartType, size = 150, color = neptunePrimaryDark }) => {
  const classes = useStyles({ size, color });

  switch (chartType) {
    case 'Pie':
    case 'ExplodedPie': {
      return <ChartPie className={classes.chartIcon} />;
    }

    case 'Bar':
    case 'PercentStackedBar':
    case 'StackedBar': {
      return (
        <ChartBar className={classNames({ [classes.chartIcon]: true, [classes.rotate]: true })} />
      );
    }

    case 'Column':
    case 'StackedColumn':
    case 'PercentStackedColumn':
    default: {
      return <ChartBar className={classes.chartIcon} />;
    }
  }
};

export default ChartIcon;
